import { InfoCircleOutlined } from "@ant-design/icons";
import { formatNumber, storeMeta } from "../../shared/utils";
import { Tooltip, Popover } from "antd";

const TAB_STYLES = {
  bestValue: {
    bg: "bg-teal-400",
  },
  topRated: {
    bg: "bg-pink-400",
  },
  priceLow: {
    bg: "bg-orange-400",
  },
};

export const ElectronicsTab = ({
  activeTab,
  onChange,
  tabsData = [],
  filterContent,
  open,
  onOpenChange,
  hasActiveFilters,
}) => {
  return (
    <div className="flex items-stretch gap-2 w-full mb-5">
      {/* <div className="flex flex-1 rounded-[12px] overflow-hidden border shadow-sm">
        {tabsData.map((tab, index) => {
          const isActive = activeTab === tab.key;
          const style = TAB_STYLES[tab.key];
          const { label = "", tooltip = "", info = {} } = tab || {};
          const { price = 0, rating = 0, reviews = 0, store = "" } = info || {};

          return (
            <button
              key={tab.key}
              onClick={() => onChange(tab.key)}
              className={`
                flex-1 transition
                px-3 py-2 sm:px-4 sm:py-3
                border-r last:border-r-0
                flex flex-col items-center justify-center
                ${isActive ? style.bg : "bg-white"}
              `}
            >
              <div
                className="
                        flex items-center justify-center gap-1
                        text-[10px] sm:text-xs md:text-sm
                        font-semibold text-gray-900
                        whitespace-nowrap
                        leading-none"
              >
                {label}
                <Tooltip title={tooltip}>
                  <InfoCircleOutlined className="text-[9px] sm:text-[10px] md:text-xs text-gray-600" />
                </Tooltip>
              </div>

              <div className="flex items-center justify-center gap-0.5 mt-0.5 sm:mt-1">
                <img
                  src={storeMeta[store]?.logo}
                  alt={store}
                  className="w-3 h-3 object-contain"
                />

                <span className="text-[10px] font-semibold text-gray-900">
                  ${price.toFixed(2)}
                </span>
              </div>

              <div className="mt-0.5 sm:mt-1 text-[10px] sm:text-xs text-gray-700 flex items-center justify-center gap-1">
                <span>{rating}</span>
                <span className="text-yellow-500">★</span>
                <span>({`${formatNumber(reviews)}`})</span>
              </div>
            </button>
          );
        })}
      </div> */}

      {/* Filter Button */}
      {/* Filter Button */}
      <Popover
        content={filterContent}
        title={null}
        trigger="click"
        placement="bottomRight"
        open={open}
        onOpenChange={onOpenChange}
      >
       <button
  className="
    relative
    flex items-center justify-center gap-1
    px-3 py-[3px]
    rounded-lg border border-black
    bg-black
    text-white
    shadow-sm
    text-[13px] font-medium
  "
>
  {/* Red dot indicator */}
  {hasActiveFilters && (
    <span className="absolute top-3 right-2 w-2 h-2 bg-red-500 rounded-full ring-2 ring-black" />
  )}

  {/* Label */}
  <span>Filter</span>

  {/* Icon */}
  <svg
    viewBox="0 0 24 24"
    className="w-3.5 h-3.5 sm:w-4 sm:h-4"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M3 4h18l-7 8v6l-4 2v-8L3 4z" />
  </svg>
</button>
      </Popover>
    </div>
  );
};
